export interface CalendarEventItem<T> {
  readonly title: string;
  readonly start: Date;
  readonly end: Date;
  readonly allDay?: boolean;
  readonly resource?: any;
  readonly dataItem?: T;
}

// Events created by another flow (e.g. counselling) carry an originType. They are surfaced with a friendly
// label and a distinct tint, and are read-only on the calendar (managed from their source flow).
export const ORIGIN_LABELS: Record<string, string> = {
  CounsellingRequest: "Counselling Session",
  Training: "Training Session",
};

export const originLabel = (originType?: string): string | undefined =>
  originType ? (ORIGIN_LABELS[originType] ?? originType) : undefined;
